import { EdgeMouseLeaveAction, EntityDiagramActionFn } from '../types';

export const edgeMouseLeaveAction: EntityDiagramActionFn<
  EdgeMouseLeaveAction
> = (state, _action, _queueEffect) => {
  return { ...state, highlightedIds: new Set() };
};
